import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { BrandingProvider } from './contexts/BrandingContext';
import { GoogleMapsProvider } from './contexts/google-map-context/GoogleMapContent';
import { PortalProvider } from './contexts/PortalContext/PortalProvider';
import { ThemeProvider } from './contexts/theme-context/ThemeProvider';
import { WebSocketProvider } from './contexts/WebSocket/WebSocketProvider';
import { WebSocketProvider as WebSocketV2Provider } from './contexts/WebSocketV2/WebSocketProvider';
import Router from './pages/router';
import { store } from './redux/store';
import MetaManager from './shared-components/MetaManager/MetaManager';

/**
 * Main body page
 */
function App() {
  return (
    <GoogleMapsProvider apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY || ''}>
      <PortalProvider>
        <BrandingProvider>
          <WebSocketProvider>
            <WebSocketV2Provider>
              <ThemeProvider>
                <Provider store={store}>
                  <div className="app">
                    <MetaManager />
                    <BrowserRouter>
                      <Router />
                    </BrowserRouter>
                  </div>
                </Provider>
              </ThemeProvider>
            </WebSocketV2Provider>
          </WebSocketProvider>
        </BrandingProvider>
      </PortalProvider>
    </GoogleMapsProvider>
  );
}

export default App;
